import { render, staticRenderFns } from "./ChuyenCocComponent.vue?vue&type=template&id=7980b706&"
import script from "./ChuyenCocComponent.vue?vue&type=script&lang=js&"
export * from "./ChuyenCocComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports